import { FormControlLabel, Radio } from '@material-ui/core';
import React from 'react';

export const RadioOptionRhf = ({ value, label, disable = false, style = {}, defaultValue, onChange = null }) => {
    return (
        <FormControlLabel
            defaultValue={defaultValue}
            value={value}
            control={<Radio />}
            label={label}
            disabled={disable}
            style={{ ...style }}
            onChange={onChange}
        />
    );
};
